import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import clsx from 'clsx'
import { getLowQualityPlaceholder, generateSrcSet } from 'libs/searchspring/components/ResultImage'

const IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960]

export function BlogCard({ blog, tileClass = 'tile-s' }) {
  const shouldUseLandscape = tileClass === 'tile-m' || tileClass === 'tile-l'
  const landscapeImage = shouldUseLandscape && blog.image_landscape ? blog.image_landscape : null
  const articleImage = blog.image_alt || blog.image

  useEffect(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update()
    }
  }, [articleImage?.src])

  return (
    <a href={blog.url} className={clsx('blog-card flex flex-col md:items-end size-full outline-card link-line-parent', tileClass)} aria-label={`Read more about ${blog.title}`}>
      <div className="blog-card__aspect relative flex flex-col-reverse gap-y-1 justify-between w-full p-margin bg-neutral-medium overflow-hidden after:content-[''] after:absolute after:inset-tl after:size-full after:bg-black-to-transparent-top after:z-3 after:pointer-events-none">
        <h3 className="h5 font-semibold text-brand-white z-5">{blog.title}</h3>
        {blog.tags && (
          <div className="flex flex-wrap items-center gap-x-0.5 z-5">
            {blog.tags
              .filter(tag => tag.startsWith('Badge:'))
              .map(tag => {
                const badgeText = tag.split('Badge:').pop()
                return (
                  <div key={tag} className="shrink-0 flex size-fit text-brand-black bg-brand-white px-0.5 py-0.375 rounded-80 overflow-hidden">
                    <span className="text-xs leading-none font-semibold uppercase">{badgeText}</span>
                  </div>
                )
              })}
          </div>
        )}
        {articleImage?.src && (
          <img
            className={clsx(
              'lazy absolute inset-tl size-full object-cover object-left',
              landscapeImage?.src && 'md:hidden'
            )}
            src={getLowQualityPlaceholder(articleImage.src)}
            data-src={articleImage.src}
            data-srcset={generateSrcSet(articleImage.src, IMAGE_WIDTHS)}
            data-sizes="50vw"
            alt={articleImage.alt || blog.title}
            width={articleImage.width}
            height={articleImage.height}
          />
        )}
        {landscapeImage?.src && (
          <img
            className="lazy md-max:hidden absolute inset-tl size-full object-cover object-left z-2"
            src={getLowQualityPlaceholder(landscapeImage.src)}
            data-src={landscapeImage.src}
            data-srcset={generateSrcSet(landscapeImage.src, IMAGE_WIDTHS)}
            data-sizes="50vw"
            alt={landscapeImage.alt || blog.title}
            width={landscapeImage.width}
            height={landscapeImage.height}
          />
        )}
      </div>

      <div className="grow flex md-max:flex-col md-max:justify-end gap-x-1 gap-y-0.5 p-margin md:py-1.5">
        {blog.excerpt && (
          <div className="richtext paragraph-b line-clamp-2">
            {blog.excerpt}
          </div>
        )}
        <div className="shrink-0 btn btn-primary btn-s btn-text w-fit md:-mt-0.25">
          <span>Read More</span>
        </div>
      </div>
    </a>
  )
}
